import MobilePage from './UiComponents/MobilePage'

const Maintenance = () => {
  return (
    <MobilePage>
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center p-8">
          <img src="/image/maintenance.png" alt="점검중" className="mx-auto" />
          <div className="text-2xl font-bold mb-4">시스템 배포 중 입니다.</div>
          <div className="text-gray-600">이용에 불편을 드려 죄송합니다.</div>
          <div className="text-gray-600">5분 후 다시 접속 부탁드립니다.</div>
        </div>
      </div>
    </MobilePage>
  )
}

export default Maintenance
